// extracted by mini-css-extract-plugin
module.exports = {"divider":"UserAttributeForm_divider_2Hg5P","lockAttributeHeader":"UserAttributeForm_lockAttributeHeader_1UjFj"};